module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.board.fetchingStatus === 'fetching') ? _c('loader-large') : [(!_vm.category) ? _c('div', {
    staticClass: "no-forums"
  }, [_vm._v("This Category Doesn't Exist")]) : _c('category-item', {
    attrs: {
      "category": _vm.category,
      "is-moderator": _vm.isModerator,
      "board-id": _vm.boardId,
      "root": _vm.root
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f9d0508!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Forums/ForumsForumList.vue
// module id = 868
// module chunks = 2